import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import { FaDownload } from "react-icons/fa";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import SpecificationViewed from "../../component/SepcificationViewed";
import FilePdf from "../../broucherPdf/filePdf";
import uspplus from "../../assets/uspstreamlineplus.png"

export default function UspStreamLine4SP() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const printerDetailsRef = useRef(null);

  const leftSidePrinterSpecification = [
    {
      title: "Print Technology",
      data: "Continuous Ink Jet",
    },
    {
      title: "Print Speed",
      data: "Up to 285m/min (5x5 font, single line)",
    },
    {
      title: "Font Matrix Configurations",
      data: "5x5, 7x5, 9x7, 12x12, 16x16, 24x24, 32x32",
    },
    {
      title: "Communication interface",
      data: "usb, ethernet,  and rs - 232",
    },
    {
      title: "Cabinet Construction",
      data: "wall mountable or free standing stainless steel cabinate",
    },
    {
      title: "Inks",
      data: "Comprehensive range of inks for a variety of applications and industry requirements ",
    },
  ];
  const rightSidePrinterSpecification = [
    {
      title: "weight",
      data: "57 ibs. (26kg)",
    },
    {
      title: "Max Print Lines",
      data: "up to 4 lines (7x5 dot), up to 5 lines (5x5 dot)",
    },
    {
      title: "Character Height",
      data: "0.07” - 0.59” (1.8mm - 15mm); up to 32 dot high font with single line of text",
    },
    {
      title: "Software Features",
      data: "Counter, lot counter, shift code, time and date, expiration date, julian date, bar code, random code",
    },
    {
      title: "Printhead Dimensions",
      data: "4.9” (124cm) long, 1.7” (44mm) in diameter, 1.6” (41mm) in height",
    },
    {
      title: "Touch Screen/Display",
      data: "simple to use, touch screen  display with pinyin input method for chinese characters",
    },
  ];
  const foodAndBeverage1 = [
    {
      productImg: Images?.industry5,
      label: "Food & Beverage",
      pageNavigate: "/byindustry/foodandbeverage",
    },
    {
      productImg: Images?.industry1,
      label: "Automobile",
      pageNavigate: "/byindustry/automobile",
    },
    {
      productImg: Images?.industry7,
      label: "Pharma",
      pageNavigate: "/byindustry/pharma",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);
  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };
  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="USP STREAMLINE 4SP"
        printerImg={Images?.productDemo}
        pdfFile={FilePdf?.STREAMLINE_4sp}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${printerDetailsVisible ? "animated" : ""
              }`}
          >
            USP STREAMLINE 4SP
          </header>
          <div
            ref={printerDetailsRef}
            // className="printerDetailsData"
            className={`printerDetailsData ${printerDetailsVisible ? "animated" : ""
              }`}
          >
            Squid Ink's Streamline 4 CIJ printing system is designed to print
            superior quality small characters on a variety of substrates:
            porous, non-porous, smooth, textured, curved, concave and more
            Printing up to 5 lines of text, the Streamline offers a reliable,
            yet cost effective solution for virtually any small character
            primary packaging application.
          </div>
          <div className="printerDetailsVideo" ref={youtubeContainerRef}>
            {/* <div className="printerYoutubeLink">
              <iframe
                // className={`youtubeVideo `}
                className={`youtubeVideo ${youtubeVideoVisible ? "animated" : ""
                  }`}
                width="300"
                height="250"
                src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style={{ borderRadius: "6px" }}
              ></iframe>
            </div> */}
            <div>
              <div
                className={`printerBrochure ${youtubeVideoVisible ? "animated" : ""
                  }`}
                style={{ cursor: "pointer" }}
                onClick={handleDivClick}
              >
                <div>
                  <div className="productImageContainer">
                    <img
                      className="w-[100%]"
                      src={uspplus}
                      alt=""
                    />
                  </div>
                  {/* Buttons */}
                  <div className="brochureImageButtons">
                    <button className="downloadBrochureBtn">
                      Download Brochure
                    </button>
                  </div>
                  <a
                    href={FilePdf?.STREAMLINE_4sp}
                    download="Usp Streamline 4SP"
                    ref={downloadLinkRef}
                    style={{ display: "none" }}
                  >
                    Download Brochure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${specificationVisible ? "animated" : ""
                    }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${specificationVisible ? "animated" : ""
                    }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <SpecificationViewed foodAndBeverage1={foodAndBeverage1} />

        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
